(function () {
  const API_BASE = "/apps/pg-wishlist";
  const ACCOUNT_SELECTOR = "[data-pg-loyalty-account]";
  const CART_SELECTOR = "[data-pg-loyalty-cart]";

  let currentState = null;
  let currentMessage = null;
  let isWorking = false;
  let pendingRewardId = null;

  function escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, "&#096;");
  }

  function formatPoints(value) {
    const points = Number(value) || 0;
    return new Intl.NumberFormat("hu-HU").format(points) + " pont";
  }

  function formatDate(value) {
    if (!value) return "";
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return "";
    return new Intl.DateTimeFormat("hu-HU", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(date);
  }

  function restoreHungarianLoyaltyText(value) {
    return String(value || "")
      .replace(/Csatlakozas a pontgyujto programhoz/g, "Csatlakoz\u00e1s a pontgy\u0171jt\u0151 programhoz")
      .replace(/Pontok jovairasa/g, "Pontok j\u00f3v\u00e1\u00edr\u00e1sa")
      .replace(/Pontmozgas/g, "Pontmozg\u00e1s")
      .replace(/kedvezmeny/g, "kedvezm\u00e9ny")
      .replace(/szallitas/g, "sz\u00e1ll\u00edt\u00e1s")
      .replace(/pontgyujto/g, "pontgy\u0171jt\u0151")
      .replace(/jovairasa/g, "j\u00f3v\u00e1\u00edr\u00e1sa")
      .replace(/utan/g, "ut\u00e1n");
  }

  function normalizeDiscountText(value) {
    return String(value || "").trim().toLowerCase();
  }

  function appliedCartDiscountText(container) {
    const parts = [container.getAttribute("data-pg-cart-discounts") || ""];
    document.querySelectorAll(".discounts__discount").forEach((element) => {
      parts.push(element.textContent || "");
    });
    return normalizeDiscountText(parts.join(" | "));
  }

  function isCouponAppliedToCart(container, coupon) {
    const discountText = appliedCartDiscountText(container);
    const code = normalizeDiscountText(coupon && coupon.code);
    const title = normalizeDiscountText(coupon && coupon.title);
    return !!((code && discountText.includes(code)) || (title && discountText.includes(title)));
  }

  async function readJson(response) {
    const text = await response.text();
    try {
      return text ? JSON.parse(text) : null;
    } catch {
      return null;
    }
  }

  async function apiGet(action) {
    const url = API_BASE + "?" + new URLSearchParams({ action }).toString();
    const response = await fetch(url, { credentials: "same-origin" });
    const json = await readJson(response);
    if (!response.ok || !json || json.ok === false) {
      const error = json && json.error ? json.error : "request_failed";
      throw new Error(errorMessage(error, response.status, action));
    }
    return json;
  }

  async function apiPost(action, body) {
    const url = API_BASE + "?" + new URLSearchParams({ action }).toString();
    const response = await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
    });
    const json = await readJson(response);
    if (!response.ok || !json || json.ok === false) {
      const error = json && json.error ? json.error : "request_failed";
      throw new Error(errorMessage(error, response.status, action));
    }
    return json;
  }

  function errorMessage(error, status, action) {
    const messages = {
      login_required: "A pontok használatához jelentkezz be a fiókodba.",
      not_enough_points: "Nincs elég pontod ehhez a kuponhoz.",
      unknown_reward: "Ez a beváltási lehetőség már nem elérhető.",
      method_not_allowed: "Ezt a műveletet most nem lehet végrehajtani.",
      shopify_admin_token_missing: "A kuponkészítés admin beállítása hiányzik.",
      discount_create_failed: "Nem sikerült létrehozni a kupont. Próbáld újra később.",
      request_failed: "Nem sikerült kapcsolódni a pontgyűjtő rendszerhez. Próbáld újra később.",
      server_error: "A pontgyűjtő rendszer most hibát adott. Próbáld újra később.",
    };

    if (error === "invalid_birthday") return "A sz\u00fclet\u00e9snap d\u00e1tuma nem \u00e9rv\u00e9nyes.";
    if (error === "birthday_already_saved") return "A sz\u00fclet\u00e9snapot csak egyszer lehet megadni.";
    if (messages[error]) return messages[error];
    if (action === "loyalty_redeem" || status >= 500) {
      return "Nem sikerült létrehozni a kupont. Próbáld újra később.";
    }
    return String(error || "Ismeretlen hiba történt.");
  }

  function getActiveCoupons(state) {
    return Array.isArray(state && state.coupons) ? state.coupons : [];
  }

  function getRewards(state) {
    return Array.isArray(state && state.rewards) ? state.rewards : [];
  }

  function getLedger(state) {
    return Array.isArray(state && state.ledger) ? state.ledger : [];
  }

  function getReward(state, rewardId) {
    return getRewards(state).find((reward) => reward.id === rewardId) || null;
  }

  function rewardMeta(reward) {
    if (reward.type === "free_shipping") return "Ingyenes szállítás";
    if (Number(reward.value) > 0) {
      return new Intl.NumberFormat("hu-HU").format(Number(reward.value)) + " Ft kedvezmény";
    }
    return reward.description || "";
  }

  function messageMarkup() {
    if (!currentMessage) return "";
    return (
      '<div class="pg-loyalty__message" data-state="' +
      escapeAttr(currentMessage.type) +
      '">' +
      escapeHtml(currentMessage.text) +
      "</div>"
    );
  }

  function couponMarkup(coupon) {
    const expires = formatDate(coupon.expiresAt);
    return (
      '<article class="pg-loyalty-coupon">' +
      '<div class="pg-loyalty-coupon__content">' +
      '<span class="pg-loyalty-coupon__eyebrow">Beváltott kupon</span>' +
      '<h4>' + escapeHtml(restoreHungarianLoyaltyText(coupon.title || coupon.code)) + '</h4>' +
      '<p class="pg-loyalty-coupon__code">' + escapeHtml(coupon.code) + '</p>' +
      (expires ? '<p class="pg-loyalty-coupon__date">Lejárat: ' + escapeHtml(expires) + '</p>' : '') +
      '</div>' +
      '<a class="button pg-loyalty__button pg-loyalty__button--coupon" href="' + escapeAttr(coupon.applyUrl || "/cart") + '">' +
      'Kupon felhasználása' +
      '</a>' +
      '</article>'
    );
  }

  function rewardMarkup(reward) {
    const canRedeem = !!reward.canRedeem;
    const missing = Number(reward.missingPoints) || 0;
    const disabled = !canRedeem || isWorking;
    const label = canRedeem ? "Beváltom" : formatPoints(missing) + " hiányzik";

    return (
      '<article class="pg-loyalty-reward">' +
      '<div>' +
      '<h4>' + escapeHtml(reward.title) + '</h4>' +
      '<p>' + escapeHtml(rewardMeta(reward)) + '</p>' +
      '<span>' + escapeHtml(formatPoints(reward.pointsCost)) + '</span>' +
      '</div>' +
      '<button class="pg-loyalty__button pg-loyalty__button--ghost" type="button" ' +
      'data-pg-loyalty-redeem="' + escapeAttr(reward.id) + '" ' +
      (disabled ? "disabled " : "") +
      (isWorking ? 'aria-busy="true" ' : "") +
      ">" +
      escapeHtml(label) +
      "</button>" +
      "</article>"
    );
  }

  function redeemConfirmMarkup(state) {
    if (!pendingRewardId) return "";

    const reward = getReward(state, pendingRewardId);
    if (!reward) return "";

    return (
      '<div class="pg-loyalty-confirm" role="region" aria-live="polite">' +
      '<div>' +
      '<h4>Kuponbeváltás</h4>' +
      '<p>' +
      escapeHtml(reward.title) +
      " beváltásához most levonjuk a pontokat, és létrehozunk egy 1 évig érvényes kupont. " +
      "A kupon más kedvezménnyel nem vonható össze. Ha a kosár értéke kisebb a kuponnál, a fennmaradó rész elvész. " +
      "A beváltott pont nem kerül vissza a pontegyenlegedbe." +
      '</p>' +
      '</div>' +
      '<div class="pg-loyalty-confirm__actions">' +
      '<button class="pg-loyalty__button pg-loyalty__button--solid" type="button" data-pg-loyalty-confirm-redeem="' + escapeAttr(reward.id) + '" ' +
      (isWorking ? 'disabled aria-busy="true"' : "") +
      '>Kupon létrehozása</button>' +
      '<button class="pg-loyalty__button pg-loyalty__button--plain" type="button" data-pg-loyalty-cancel-redeem ' +
      (isWorking ? "disabled" : "") +
      '>Mégsem</button>' +
      '</div>' +
      '</div>'
    );
  }

  function earnMarkup(rule) {
    const points = Number(rule.points) || 0;

    return (
      '<article class="pg-loyalty-earn">' +
      '<span class="pg-loyalty-earn__icon" aria-hidden="true">' + earnIconMarkup(rule.id) + '</span>' +
      '<div class="pg-loyalty-earn__body">' +
      '<h4>' + escapeHtml(rule.title) + '</h4>' +
      '<p>' + escapeHtml(rule.description) + '</p>' +
      (points ? '<span class="pg-loyalty-earn__points">' + escapeHtml(formatPoints(points)) + '</span>' : '') +
      '</div>' +
      '</article>'
    );
  }

  function earnIconMarkup(ruleId) {
    if (ruleId === "paid-order") {
      return '<svg viewBox="0 0 32 32"><path d="M8 11h16l-1 15H9L8 11Zm4 0V8a4 4 0 0 1 8 0v3"/></svg>';
    }
    if (ruleId === "join-program") {
      return '<svg viewBox="0 0 32 32"><path d="M5 13h22v14H5V13Zm-1-5h24v5H4V8Zm12 0v19M16 8c-4 0-7-1-7-4 0-2 2-3 4-2 2 1 3 4 3 6Zm0 0c4 0 7-1 7-4 0-2-2-3-4-2-2 1-3 4-3 6Z"/></svg>';
    }
    return '<svg viewBox="0 0 32 32"><path d="m16 3 2.5 7.5L26 13l-7.5 2.5L16 23l-2.5-7.5L6 13l7.5-2.5L16 3Zm9 17 1.2 3.8L30 25l-3.8 1.2L25 30l-1.2-3.8L20 25l3.8-1.2L25 20Z"/></svg>';
  }

  function birthdayMonthDay(customer) {
    const birthday = String((customer && customer.birthday) || "");
    if (/^\d{4}-\d{2}-\d{2}$/.test(birthday)) return birthday.slice(5);
    const monthDay = String((customer && customer.birthdayMonthDay) || "");
    return /^\d{2}-\d{2}$/.test(monthDay) ? monthDay : "";
  }

  function birthdayDisplay(customer) {
    const monthDay = birthdayMonthDay(customer);
    const match = /^(\d{2})-(\d{2})$/.exec(monthDay);
    if (!match) return "";
    return Number(match[1]) + ". " + Number(match[2]) + ".";
  }

  function optionMarkup(value, label, selectedValue) {
    return '<option value="' + escapeAttr(value) + '" ' + (value === selectedValue ? "selected" : "") + '>' + escapeHtml(label) + '</option>';
  }

  function birthdaySelectMarkup(customer) {
    const monthDay = birthdayMonthDay(customer);
    const selectedMonth = monthDay ? monthDay.slice(0, 2) : "";
    const selectedDay = monthDay ? monthDay.slice(3, 5) : "";
    const months = [
      "Janu\u00e1r",
      "Febru\u00e1r",
      "M\u00e1rcius",
      "\u00c1prilis",
      "M\u00e1jus",
      "J\u00fanius",
      "J\u00falius",
      "Augusztus",
      "Szeptember",
      "Okt\u00f3ber",
      "November",
      "December",
    ];
    let monthOptions = '<option value="">H\u00f3nap</option>';
    let dayOptions = '<option value="">Nap</option>';

    months.forEach((label, index) => {
      const value = String(index + 1).padStart(2, "0");
      monthOptions += optionMarkup(value, label, selectedMonth);
    });

    for (let day = 1; day <= 31; day += 1) {
      const value = String(day).padStart(2, "0");
      dayOptions += optionMarkup(value, String(day) + ".", selectedDay);
    }

    return (
      '<div class="pg-loyalty-earn__date-row">' +
      '<select class="pg-loyalty-earn__select" name="birthday_month" required ' + (isWorking ? "disabled " : "") + 'aria-label="Sz\u00fclet\u00e9si h\u00f3nap">' + monthOptions + '</select>' +
      '<select class="pg-loyalty-earn__select" name="birthday_day" required ' + (isWorking ? "disabled " : "") + 'aria-label="Sz\u00fclet\u00e9si nap">' + dayOptions + '</select>' +
      '</div>'
    );
  }

  function birthdayEarnMarkup(customer) {
    const birthdayLabel = birthdayDisplay(customer);

    return (
      '<article class="pg-loyalty-earn pg-loyalty-earn--action">' +
      '<span class="pg-loyalty-earn__icon pg-loyalty-earn__icon--birthday" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M7 15h18v12H7V15Zm-2 12h22v3H5v-3Zm6-12v-5h4v5m2 0v-5h4v5M13 7c0-2 2-3 2-5 2 2 2 4 0 5h-2Zm8 0c0-2 2-3 2-5 2 2 2 4 0 5h-2ZM7 20c3 0 3 3 6 3s3-3 6-3 3 3 6 3"/></svg></span>' +
      '<div class="pg-loyalty-earn__body">' +
      '<h4>Sz\u00fclet\u00e9snapi b\u00f3nusz</h4>' +
      '<p>A sz\u00fclet\u00e9snapodon automatikusan 500 pontot \u00edrunk j\u00f3v\u00e1.</p>' +
      (birthdayLabel
        ? '<div class="pg-loyalty-earn__saved"><strong>M\u00e1r megadtad: ' + escapeHtml(birthdayLabel) + '</strong></div>'
        : '<button class="pg-loyalty__button pg-loyalty__button--ghost" type="button" data-pg-loyalty-birthday-toggle>Add meg a sz\u00fclet\u00e9snapod</button>' +
          '<form class="pg-loyalty-earn__form" data-pg-loyalty-birthday-form hidden>' +
          birthdaySelectMarkup(customer) +
          '<button class="pg-loyalty__button pg-loyalty__button--ghost" type="submit" ' +
          (isWorking ? 'disabled aria-busy="true" ' : "") +
          '>Ment\u00e9s</button>' +
          '</form>') +
      '<span class="pg-loyalty-earn__points">500 pont</span>' +
      '</div>' +
      '</article>'
    );
  }

  function facebookEarnMarkup(customer) {
    const facebookClaimed = !!(customer && customer.facebookFollowClaimedAt);
    const facebookUrl = (customer && customer.facebookPageUrl) || "https://facebook.com/puzzlegarden";

    return (
      '<article class="pg-loyalty-earn pg-loyalty-earn--action">' +
      '<span class="pg-loyalty-earn__icon pg-loyalty-earn__icon--facebook" aria-hidden="true">f</span>' +
      '<div class="pg-loyalty-earn__body">' +
      '<h4>K\u00f6vess Facebookon!</h4>' +
      '<p>K\u00f6vess minket Facebookon, \u00e9s egyszeri 300 pontot \u00edrhatsz j\u00f3v\u00e1.</p>' +
      '<button class="pg-loyalty__button pg-loyalty__button--facebook" type="button" data-pg-loyalty-facebook-claim data-pg-facebook-url="' + escapeAttr(facebookUrl) + '" ' +
      ((facebookClaimed || isWorking) ? "disabled " : "") +
      (isWorking ? 'aria-busy="true" ' : "") +
      '>' + (facebookClaimed ? "M\u00e1r j\u00f3v\u00e1\u00edrva" : "Facebook oldal megnyit\u00e1sa") + '</button>' +
      '<span class="pg-loyalty-earn__points">300 pont</span>' +
      '</div>' +
      '</article>'
    );
  }

  function ledgerMarkup(item) {
    const points = Number(item.points) || 0;
    const sign = points > 0 ? "+" : "";
    const date = formatDate(item.createdAt);
    return (
      '<li class="pg-loyalty-ledger__item">' +
      '<div>' +
      '<strong>' + escapeHtml(restoreHungarianLoyaltyText(item.title || "Pontmozg\u00e1s")) + '</strong>' +
      (date ? '<span>' + escapeHtml(date) + '</span>' : '') +
      '</div>' +
      '<b data-positive="' + String(points >= 0) + '">' + sign + escapeHtml(formatPoints(points)) + '</b>' +
      '</li>'
    );
  }

  function renderAccount(container, state) {
    const customer = (state && state.customer) || {};
    const balance = Number(customer.balance) || 0;
    const isMember = !!customer.isMember;
    const coupons = getActiveCoupons(state);
    const rewards = getRewards(state);
    const ledger = getLedger(state);
    const activeCouponPoints = coupons.reduce(
      (total, coupon) => total + Math.max(0, Number(coupon && coupon.pointsCost) || 0),
      0
    );
    const earnRules = Array.isArray(state && state.earnRules)
      ? state.earnRules.filter((rule) => rule && rule.id !== "birthday" && rule.id !== "facebook-follow")
      : [];
    const nextReward = state && state.nextReward ? state.nextReward : null;
    const nextCost = nextReward ? Number(nextReward.pointsCost) || 0 : 0;
    const progress = nextCost > 0 ? Math.min(100, Math.round((balance / nextCost) * 100)) : 100;

    if (!isMember) {
      container.innerHTML =
        '<div class="pg-loyalty__panel pg-loyalty__panel--join">' +
        '<div>' +
        '<p class="pg-loyalty__eyebrow">Puzzle Garden Klub pontok</p>' +
        '<h2>Pontgyűjtés a fiókodban</h2>' +
        '<p>Csatlakozás után azonnal 300 pont jár, a fizetett rendelések után pedig automatikusan gyűlnek a pontok.</p>' +
        '</div>' +
        '<button class="pg-loyalty__button pg-loyalty__button--solid" type="button" data-pg-loyalty-join ' +
        (isWorking ? 'disabled aria-busy="true"' : "") +
        '>Csatlakozom</button>' +
        '</div>' +
        messageMarkup();
      return;
    }

    container.innerHTML =
      '<div class="pg-loyalty__panel">' +
      '<div class="pg-loyalty__header">' +
      '<div>' +
      '<p class="pg-loyalty__eyebrow">Puzzle Garden Klub pontok</p>' +
      '<h2>' + escapeHtml(formatPoints(balance)) + '</h2>' +
      '<p>' +
      (nextReward
        ? escapeHtml(formatPoints(nextReward.missingPoints)) + ' kell még ehhez: ' + escapeHtml(nextReward.title)
        : "Minden kupon elérhető a pontegyenlegeddel.") +
      '</p>' +
      '</div>' +
      '<div class="pg-loyalty__stats pg-loyalty__stats--quiet">' +
      '<span><b>' + escapeHtml(String(coupons.length)) + ' db</b>aktív kupon</span>' +
      '<span><b>' + escapeHtml(formatPoints(activeCouponPoints)) + '</b>kuponban</span>' +
      '</div>' +
      '</div>' +
      '<div class="pg-loyalty__progress" aria-hidden="true"><span style="width:' + progress + '%"></span></div>' +
      messageMarkup() +
      (coupons.length
        ? '<div class="pg-loyalty__section"><h3>Aktív kuponok</h3><div class="pg-loyalty__coupon-grid">' + coupons.map(couponMarkup).join("") + '</div></div>'
        : '<div class="pg-loyalty__empty">Nincs aktív kuponod.</div>') +
      '<div class="pg-loyalty__section"><h3>Beváltás</h3>' + redeemConfirmMarkup(state) + '<div class="pg-loyalty__reward-grid">' + rewards.map(rewardMarkup).join("") + '</div></div>' +
      '<div class="pg-loyalty__section"><h3>Pontgyűjtés</h3><p class="pg-loyalty__section-intro">Minden elköltött 100 Ft után 1 pont jár. Egy rendelésben a legmagasabb elért kosárérték-bónuszt írjuk jóvá.</p><div class="pg-loyalty__earn-grid">' +
      earnRules.map(earnMarkup).join("") +
      birthdayEarnMarkup(customer) +
      '<article class="pg-loyalty-earn"><span class="pg-loyalty-earn__icon" aria-hidden="true">' + earnIconMarkup("bonus") + '</span><div class="pg-loyalty-earn__body"><h4>Kosárérték-bónusz</h4><p>20 000 Ft: +500 pont · 60 000 Ft: +1500 pont · 80 000 Ft: +2500 pont · 100 000 Ft: +5000 pont</p><span class="pg-loyalty-earn__points">rendelésenként a legmagasabb szint</span></div></article>' +
      '</div></div>' +
      (ledger.length
        ? '<div class="pg-loyalty__section"><details class="pg-loyalty-details"><summary>Korábbi pontmozgások</summary><ul class="pg-loyalty-ledger">' + ledger.map(ledgerMarkup).join("") + '</ul></details></div>'
        : "") +
      '<p class="pg-loyalty__terms-link"><a href="/pages/pontgyujtesi-szabalyzat">Pontgyűjtési szabályzat</a></p>' +
      '</div>';
  }

  function renderCart(container, state) {
    const coupons = getActiveCoupons(state);
    if (!coupons.length) {
      container.hidden = true;
      container.innerHTML = "";
      return;
    }

    const coupon = coupons.find((item) => !isCouponAppliedToCart(container, item));
    if (!coupon) {
      container.hidden = true;
      container.innerHTML = "";
      return;
    }

    const expires = formatDate(coupon.expiresAt);
    container.hidden = false;
    container.innerHTML =
      '<div class="pg-loyalty-cart__inner">' +
      '<div>' +
      '<p class="pg-loyalty-cart__eyebrow">Elérhető pontkupon</p>' +
      '<h2>Van egy beváltott kuponod a fiókodban.</h2>' +
      '<p>' + escapeHtml(coupon.title || coupon.code) + (expires ? ' - lejárat: ' + escapeHtml(expires) : '') + '</p>' +
      '</div>' +
      '<a class="button pg-loyalty__button pg-loyalty__button--coupon" href="' + escapeAttr(coupon.applyUrl || "/cart") + '">Kupon alkalmazása</a>' +
      '</div>';
  }

  function renderLoading() {
    document.querySelectorAll(ACCOUNT_SELECTOR).forEach((container) => {
      container.innerHTML =
        '<div class="pg-loyalty__loading"><span class="pg-loyalty__spinner" aria-hidden="true"></span><span>Pontjaid betöltése...</span></div>';
    });
  }

  function renderError(error) {
    document.querySelectorAll(ACCOUNT_SELECTOR).forEach((container) => {
      container.innerHTML =
        '<div class="pg-loyalty__panel pg-loyalty__panel--error">' +
        '<h2>A pontgyűjtő most nem elérhető</h2>' +
        '<p>' + escapeHtml(error && error.message ? error.message : "Kérlek próbáld újra később.") + '</p>' +
        '</div>';
    });
    document.querySelectorAll(CART_SELECTOR).forEach((container) => {
      container.hidden = true;
      container.innerHTML = "";
    });
  }

  function renderAll(state) {
    document.querySelectorAll(ACCOUNT_SELECTOR).forEach((container) => renderAccount(container, state));
    document.querySelectorAll(CART_SELECTOR).forEach((container) => renderCart(container, state));
  }

  async function refresh() {
    const hasTarget = document.querySelector(ACCOUNT_SELECTOR) || document.querySelector(CART_SELECTOR);
    if (!hasTarget) return;

    try {
      if (!currentState) renderLoading();
      currentState = await apiGet("loyalty_status");
      renderAll(currentState);
    } catch (error) {
      renderError(error);
    }
  }

  async function runAction(button, callback) {
    if (isWorking) return;
    isWorking = true;
    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    }
    renderAll(currentState || { customer: {} });

    try {
      await callback();
      await refresh();
    } catch (error) {
      currentMessage = {
        type: "error",
        text: error && error.message ? error.message : "Nem sikerült végrehajtani a műveletet.",
      };
      renderAll(currentState || { customer: {} });
    } finally {
      isWorking = false;
      if (button) {
        button.disabled = false;
        button.removeAttribute("aria-busy");
      }
      renderAll(currentState || { customer: {} });
    }
  }

  document.addEventListener("click", (event) => {
    const joinButton = event.target.closest("[data-pg-loyalty-join]");
    if (joinButton) {
      runAction(joinButton, async () => {
        currentMessage = { type: "success", text: "Csatlakoztál a pontgyűjtő programhoz." };
        currentState = await apiPost("loyalty_join");
      });
      return;
    }

    const redeemButton = event.target.closest("[data-pg-loyalty-redeem]");
    if (redeemButton) {
      const rewardId = redeemButton.getAttribute("data-pg-loyalty-redeem");
      pendingRewardId = rewardId;
      currentMessage = null;
      renderAll(currentState || { customer: {} });
      return;
    }

    const cancelRedeemButton = event.target.closest("[data-pg-loyalty-cancel-redeem]");
    if (cancelRedeemButton) {
      pendingRewardId = null;
      currentMessage = null;
      renderAll(currentState || { customer: {} });
      return;
    }

    const confirmRedeemButton = event.target.closest("[data-pg-loyalty-confirm-redeem]");
    if (confirmRedeemButton) {
      const rewardId = confirmRedeemButton.getAttribute("data-pg-loyalty-confirm-redeem");

      runAction(confirmRedeemButton, async () => {
        const result = await apiPost("loyalty_redeem", { reward_id: rewardId });
        currentState = result.status || currentState;
        pendingRewardId = null;
        currentMessage = { type: "success", text: "A kupon elkészült, és megjelent a fiókodban." };
      });
    }
  });

  document.addEventListener("click", (event) => {
    const birthdayToggle = event.target.closest("[data-pg-loyalty-birthday-toggle]");
    if (birthdayToggle) {
      const form = birthdayToggle.parentElement.querySelector("[data-pg-loyalty-birthday-form]");
      if (form) {
        form.hidden = false;
        birthdayToggle.hidden = true;
      }
      return;
    }

    const facebookButton = event.target.closest("[data-pg-loyalty-facebook-claim]");
    if (!facebookButton) return;

    const facebookUrl = facebookButton.getAttribute("data-pg-facebook-url");
    if (facebookUrl) window.open(facebookUrl, "_blank", "noopener");

    runAction(facebookButton, async () => {
      const result = await apiPost("loyalty_facebook_follow_claim");
      currentState = result.status || currentState;
      currentMessage = { type: "success", text: "J\u00f3v\u00e1\u00edrtuk a Facebook k\u00f6vet\u00e9s\u00e9rt j\u00e1r\u00f3 300 pontot." };
    });
  });

  document.addEventListener("submit", (event) => {
    const form = event.target.closest("[data-pg-loyalty-birthday-form]");
    if (!form) return;

    event.preventDefault();

    const monthInput = form.querySelector('[name="birthday_month"]');
    const dayInput = form.querySelector('[name="birthday_day"]');
    const month = monthInput ? monthInput.value : "";
    const day = dayInput ? dayInput.value : "";
    const birthday = month && day ? month + "-" + day : "";
    const button = form.querySelector('button[type="submit"]');

    runAction(button, async () => {
      const result = await apiPost("loyalty_birthday_save", { birthday });
      currentState = result.status || currentState;
      currentMessage = {
        type: "success",
        text: "Elmentett\u00fck a sz\u00fclet\u00e9snapod. Az 500 pont a sz\u00fclet\u00e9snapodon automatikusan j\u00f3v\u00e1\u00edr\u00f3dik.",
      };
    });
  });

  document.addEventListener("DOMContentLoaded", refresh);
  window.addEventListener("pg:loyalty:refresh", refresh);
})();
